export default __webpack_public_path__ + "static/media/traffic-layer.e3aac9a6.svg";